import { render } from "./mono.vue?vue&type=template&id=16278b01&scoped=true"
import script from "./mono.vue?vue&type=script&lang=js"
export * from "./mono.vue?vue&type=script&lang=js"

import "./mono.vue?vue&type=style&index=0&id=16278b01&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16278b01"]])

export default __exports__